import * as yup from 'yup';

let paymentMethodValidationForm = yup.object().shape({
    name: yup.string().required("Name is required"),
})

export {
  paymentMethodValidationForm
}